import { oc } from '@orpc/contract';
import { documentSchema, updateDocumentMetaInputSchema } from '../schemas/documents.schemas.js';
/**
 * PATCH over the metadata only. The bytes never change here: correcting a file is
 * `POST /api/documents/{id}/replace`, which keeps both rows and the replacement trail.
 */
export const updateDocumentMetaContract = oc
    .route({
    method: 'PATCH',
    path: '/documents/{id}',
    tags: ['Documents'],
    summary: 'Update a document’s category, title, dates or links',
})
    .input(updateDocumentMetaInputSchema)
    .output(documentSchema);
//# sourceMappingURL=update-document-meta.contract.js.map